import waRequest from './wa-request';

export const apiBase = '/travel/v2';

function searchItinerariesAndExpatriations(config) {
  const {
    params: {locale, page, size, sort},
    data,
    signal,
  } = config;

  return waRequest.requestAuthenticated({
    url: `${apiBase}/travel/searches`,
    method: 'post',
    params: {
      locale,
      page,
      size,
      sort,
    },
    data,
    signal,
  });
}

function getTravelPersonsList({params: {locale, page, size}, data, signal}) {
  return waRequest.requestAuthenticated({
    url: `${apiBase}/travel/persons/searches`,
    method: 'post',
    params: {
      detailLevel: 'PERSON',
      locale,
      page,
      size,
    },
    data,
    signal,
  });
}

function initiateExport({params: {locale, requestParams, createUrl}, data: {filterParams}}) {
  const {
    accountInfo,
    includeOrganizations,
    includePersonTypes,
    emails,
    emergencyContacts,
    names,
    phones,
    optionalFields,
    tripSegments,
    includeExpatriations,
    includeStopovers,
    identifiers,
    organizationId,
  } = requestParams;

  const url = `${apiBase}/travel/person-exports`;

  return waRequest.requestAuthenticated({
    url: url,
    method: 'post',
    params: {
      organizationId,
      createUrl,
      accountInfo,
      includeOrganizations,
      includePersonTypes,
      emails,
      emergencyContacts,
      names,
      phones,
      locale,
      optionalFields,
      tripSegments,
      includeExpatriations,
      includeStopovers,
      identifiers,
    },
    data: filterParams,
  });
}

/**
 * @param {Object} config
 * @param {Object} config.pathParams
 * @param {string} config.pathParams.filterField - The filter field name (e.g. 'flightNumber', 'airline')
 * @param {Object} [config.params] - Query params forwarded as-is (e.g. { page, size })
 * @param {Object} [config.data] - POST body (e.g. { organizationIds, valueLike })
 */
function getTravelFilterFieldValues({pathParams: {filterField}, params, data}) {
  return waRequest.requestAuthenticated({
    url: `${apiBase}/travel/filter-values/${filterField}/searches`,
    method: 'POST',
    params,
    data,
  });
}

function getSavedSearches({params: {page = 0, size = 25}, data}) {
  const url = `${apiBase}/travel/saved-searches/searches`;

  return waRequest.requestAuthenticated({
    url: url,
    method: 'POST',
    params: {
      page,
      size,
    },
    data,
  });
}

function updateSavedSearch({pathParams: {id}, data: {dateRangeType, description, filter, name, organizationId}}) {
  const url = `${apiBase}/travel/saved-searches/${id}`;

  return waRequest.requestAuthenticated({
    url: url,
    method: 'PUT',
    data: {
      dateRangeType,
      description,
      filter,
      name,
      organizationId,
    },
  });
}

function deleteSavedSearch({pathParams: {id}}) {
  const url = `${apiBase}/travel/saved-searches/${id}`;

  return waRequest.requestAuthenticated({url: url, method: 'DELETE'});
}

function createSavedSearch({data: {dateRangeType, description, filter, name, organizationId}}) {
  const url = `${apiBase}/travel/saved-searches`;

  return waRequest.requestAuthenticated({
    url: url,
    method: 'POST',
    data: {
      dateRangeType,
      description,
      filter,
      name,
      organizationId,
    },
  });
}

function getCustomFieldsAutocomplete(config) {
  const {pathParams, ...restConfig} = config;
  const {filterField, fieldId} = pathParams;

  return waRequest.requestAuthenticated({
    url: `${apiBase}/travel/filter-values/${filterField}/${fieldId}/searches`,
    method: 'POST',
    ...restConfig,
  });
}

function createSavedSearchSchedule({pathParams: {searchId}, data}) {
  const url = `${apiBase}/travel/saved-searches/${searchId}/schedules`;

  return waRequest.requestAuthenticated({url: url, method: 'POST', data});
}

function updateSavedSearchSchedule({pathParams: {searchId, scheduleId}, data}) {
  const url = `${apiBase}/travel/saved-searches/${searchId}/schedules/${scheduleId}`;

  return waRequest.requestAuthenticated({url: url, method: 'PUT', data});
}

function deleteSavedSearchSchedule({pathParams: {searchId, scheduleId}}) {
  const url = `${apiBase}/travel/saved-searches/${searchId}/schedules/${scheduleId}`;

  return waRequest.requestAuthenticated({url: url, method: 'DELETE'});
}

function getSavedSearchSchedule({pathParams: {searchId, id}, signal}) {
  const url = `${apiBase}/travel/saved-searches/${searchId}/schedules/${id}`;

  return waRequest.requestAuthenticated({url: url, method: 'GET', signal});
}

function getSavedSearchSchedules({pathParams: {clientId}, signal}) {
  const url = `${apiBase}/organizations/${clientId}/travel/saved-searches/schedules`;

  return waRequest.requestAuthenticated({
    url: url,
    method: 'GET',
    params: {
      name: clientId,
    },
    signal,
  });
}

export default {
  searchItinerariesAndExpatriations,
  getTravelPersonsList,
  initiateExport,
  getTravelFilterFieldValues,
  getSavedSearches,
  updateSavedSearch,
  deleteSavedSearch,
  createSavedSearch,
  getCustomFieldsAutocomplete,
  getSavedSearchSchedule,
  deleteSavedSearchSchedule,
  updateSavedSearchSchedule,
  createSavedSearchSchedule,
  getSavedSearchSchedules,
};
